import { jsx } from '@emotion/react';
import { forwardRef, VideoHTMLAttributes } from 'react';

type VideoProps = VideoHTMLAttributes<HTMLVideoElement>;

export default forwardRef<HTMLVideoElement, VideoProps>(
  ({ ...props }: VideoProps, ref) => jsx(`video`, { ref, ...props }),
);
